class MeetPerson extends HTMLElement {
  constructor() {
    super();
    this.people = this.querySelectorAll('[data-person]');
    this.modal = this.querySelector('[data-modal]');
    this.modalClose = this.querySelector('[data-modal-close]');
    this.modalImage = this.querySelector('[data-modal-img]');
    this.modalPersonName = this.querySelector('[data-modal-name]');
    this.modalBody = this.querySelector('[data-modal-body]');
    this.docBody = document.querySelector('body');
    this.overlay = document.querySelector('[data-pop-overlay]');

    this.initEvents();
  }

  initEvents() {
    const _this = this;
    this.people.forEach((person) => {
      person.addEventListener('click', function(e) {
        _this.setPerson(this);
        _this.openModal()
      });
    });
    this.overlay.addEventListener('click', (e) => {
      this.closeModal()
    });
    this.modalClose.addEventListener('click', (e) => {
      this.closeModal()
    });
    const params = new URLSearchParams(window.location.search);
    if (params.has('person') === true) {
      const personId = params.get('person');
      this.people.forEach((person) => {
        if(person.dataset.person == personId) {
          const newClick = new Event('click');
          person.dispatchEvent(newClick)
        }
      })
    }
  }

  setPerson(person) {
    const image = person.querySelector('[data-image]') ? person.querySelector('[data-image]').innerHTML : '';
    const personName = person.querySelector('[data-name]') ? person.querySelector('[data-name]').innerHTML : '';
    const body = person.querySelector('[data-description]') ? person.querySelector('[data-description]').innerHTML : '';
    this.modalImage.innerHTML = image;
    this.modalPersonName.innerHTML = personName;
    this.modalBody.innerHTML = body;
  }

  openModal() {
    this.modal.classList.add('opened');
    this.docBody.classList.add('popup-opened');
  }

  closeModal() {
    this.modal.classList.remove('opened');
    this.docBody.classList.remove('popup-opened');
  }
}

customElements.define('meet-person', MeetPerson);